import { useEffect } from 'react';
import { breakpoints, Button, Dialog, Inline, LinkButton, Stack } from '@etg/wings';
import { useSiteContext, useTranslation, useProperty } from '@eti/providers';
import { css } from '@eti/styles';
import { useHistory, useLocation } from 'react-router-dom';
import { BrandLogo, DangerousHtmlContent } from '@eti/components';
import { useToggle } from '../../../common/custom-hooks/toggle';
import { routes } from '../../../constants/routesAndApisConstants';

const siteLogo = css`
  height: 32px;
`;

const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const RedirectClosedBrandModal = () => {
  const { isOpen, handleClose, handleToggle: toggleConfirmOverlay, handleOpen } = useToggle();

  const { t } = useTranslation();
  const { p } = useProperty();
  const history = useHistory();
  const location = useLocation();
  const { brand } = useSiteContext();

  const closedOldBrand = new URLSearchParams(location?.search).get('closedBrand');
  const newBrand = brand.code;

  useEffect(() => {
    if (closedOldBrand && p('IbeClient.RedirectCustomerToAnotherSiteModal.Enabled')) {
      handleOpen();
    }
  }, [closedOldBrand, handleOpen, p]);

  if (!closedOldBrand || !newBrand) {
    return null;
  }

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="closed-down-brand"
      isOpen={isOpen}
      onDismiss={handleClose}
      title={t('StartPage.RedirectSiteModal.Title')}
    >
      <Stack spacing={32}>
        <Stack align="center">
          <BrandLogo
            brand={closedOldBrand}
            className={siteLogo}
            data-testid="redirect-closed-site-brand-old-brand"
            shouldUseContrast
          />
          <DangerousHtmlContent content={t('StartPage.RedirectSiteModal.IsNow.Text')} />
          <Inline align="center">
            <BrandLogo
              brand={newBrand}
              className={siteLogo}
              data-testid="redirect-closed-site-brand-new-brand"
              shouldUseContrast
            />
          </Inline>
        </Stack>
        <Stack>
          <DangerousHtmlContent
            content={t(
              'StartPage.RedirectSiteModal.Description.Text',
              capitalizeFirstLetter(closedOldBrand),
              capitalizeFirstLetter(newBrand),
            )}
          />
          <LinkButton onClick={() => history.push(routes.CLOSED_DOWN_BRAND)}>
            {t('StartPage.RedirectSiteModal.ReadMore.Link.Label')}
          </LinkButton>
          <Inline align="end" collapseBelow={breakpoints._768} spacing={8}>
            <Button onClick={() => handleClose()} onClose={toggleConfirmOverlay} variant="primary">
              {t('StartPage.RedirectSiteModal.Button.Text')}
            </Button>
          </Inline>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default RedirectClosedBrandModal;
